@if (displayInfo$ | async; as sectionInfo) {
  <div [dir]="dir$ | async" [class.--templates]="usage === 'templates'">
    <float-ui-content #infoContent>
      <span class="gd-section-info__label">{{label}}</span>
      <section class="tw-flex tw-flex-col tw-gap-4 tw-mt-6">
        @if (sectionInfo.updatedAt && sectionInfo.updatedAt !== sectionInfo.createdAt) {
          <div
            class="tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-3">
            <img [attr.src]="sectionInfo.updatedBy.userImage"
              class="gd-section-info__user-image">
              <div class="tw-flex tw-flex-col">
                <span i18n>Updated by: </span>
                <span class="tw-flex tw-flex-row tw-gap-2 tw-items-center">
                  <span class="gd-section-info__user-name"
                    #updatedByName
                    #tooltip="matTooltip"
                    [matTooltip]="sectionInfo.updatedBy.name"
                    [matTooltipDisabled]="doesNameFitContainer(updatedByName)">
                    <b>{{sectionInfo.updatedBy.name}}</b>
                  </span>
                  <span>|</span>
                  <span style="font-size: 12px;" dir="ltr">
                    {{sectionInfo.updatedAt | gdDateTransform}}
                  </span>
                </span>
              </div>
            </div>
          }
          <div class="tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-3">
            <img [attr.src]="sectionInfo.createdBy.userImage"
              class="gd-section-info__user-image">
              <div class="tw-flex tw-flex-col">
                <span i18n>Created by: </span>
                <span class="tw-flex tw-flex-row tw-gap-2 tw-items-center">
                  <span class="gd-section-info__user-name"
                    #createdByName
                    #tooltip="matTooltip"
                    [matTooltip]="sectionInfo.createdBy.name"
                    [matTooltipDisabled]="doesNameFitContainer(createdByName)">
                    <b>{{sectionInfo.createdBy.name}}</b>
                  </span>
                  <span>|</span>
                  <span style="font-size: 12px;" dir="ltr">
                    {{sectionInfo.createdAt | gdDateTransform}}
                  </span>
                </span>
              </div>
            </div>
          </section>
          <!-- Quick workaround for popper arrow when background is white -->
          @if (usage === 'templates') {
            <span class="gd-section-info__popper-arrow-bg"></span>
          }
        </float-ui-content>
        <mat-icon fontSet="fal"
          class="gd-section-info__icon"
          [floatUi]="infoContent"
          [fontIcon]="usage === 'templates' ? 'fa-angle-down' : 'fa-info-circle'"
          [showTrigger]="trigger"
          applyClass="gd-section-info__popper"
          applyArrowClass="gd-section-info__popper-arrow"
          [hideOnClickOutside]="true"
          [hideOnScroll]="true"
          [placement]="placement">
        </mat-icon>
      </div>
    }
